module.exports = __webpack_public_path__ + "img/light.ede07c1e.svg";